import { observable } from "@legendapp/state";

import { auth$ } from "../auth";
import type { User } from "./auth.types";

// Type cast for better types on user$
export const user$ = observable(auth$.user as unknown as User);
